$('.blog-dropdown select').on('change', function(){
	if(jQuery(this).val().length){
		window.location.href = jQuery(this).val();
	}
});

$(window).on('scroll', function() {
	if($(this).scrollTop() > 1000){
		$('.btn-right-fixed').fadeIn();
	}else{
		$('.btn-right-fixed').fadeOut();
	}
});

var sliderprojects;

function projectsliderSettings(){

	var sliderSettings = {
		infiniteLoop: true,
		pager: false,
		controls: true,
		minSlides: 1,
		maxSlides: 1,
		moveSlides: 1,
		slideWidth: 380,
	};

	var sliderSettings2 = {
		infiniteLoop: true,
		pager: false,
		controls: true,
		minSlides: 5,
		maxSlides: 5,
		moveSlides: 1,
		slideWidth: 380,
	};

	return ($(window).width()>991) ? sliderSettings2 : sliderSettings;
}

function projectsliderReload() {
	sliderprojects.reloadSlider(projectsliderSettings());
}

if($('.projects').length ){
	sliderprojects = $('.projects').bxSlider(projectsliderSettings());

	$(window).resize(function(){
		projectsliderReload();
	});
}


// WEBPACK FOOTER //
// ./scripts/includes/home.js